/**
 * habamedia
 * @description Used in carmarket to get data from the server
 */

import axios from 'axios'
import store from '@/store'

//import router from "@/router"

// let hostName = window.location.hostname

// if (process.env.NODE_ENV === 'development') {
// 	console.log('Development')
// 	hostName = 'localhost:8888'
// }

let baseUrl = location.protocol + '//' + location.hostname
if (
	// (location.port &&
	location.hostname === 'localhost' ||
	location.hostname === '192.168.0.115' ||
	location.hostname === '127.0.0.1'
) {
	// baseUrl += '/darmas/joomla4'
}

console.log('baseUrl', baseUrl)

const viewUrl = 'index.php?option=com_darmas&view=carmarket&format=json&task='
const sendRequestUrl =
	baseUrl +
	'/index.php?option=com_darmas&format=json&view=carmarket&task=sendrequest'
const apiClient = axios.create({
	baseURL: baseUrl,
	withCredentials: false,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
})

export default {
	setMetaData(title = null, pageTitle = null, metaData = null) {
		if (title) {
			document.title = title + ' | Automobile Darmas GmbH'
		}
		if (pageTitle) {
			store.state.pageTitle = pageTitle
		}
	},
	getStoreData(alias) {
		return apiClient(viewUrl + 'getstore&store=' + alias)
	},
	getFormToken() {
		return apiClient.get(viewUrl + 'getformtoken')
	},
	verifyRecaptchaToken(token) {
		return apiClient.get(viewUrl + 'verifyrecaptchatoken&t=' + token)
	},
	sendRequestMessage(data, token) {
		return axios.post(sendRequestUrl + '&' + token + '=1', data)
	},
	urlToCarDetails(carId) {
		return 'https://darmas.de/fahrzeugmarkt/details/' + carId
	},
	copyToClipboard(input) {
		const element = document.getElementById(input)

		this.$toast('Link zum Fahrzeug kopiert', {
			type: 'success',
		})
		element.select()
		element.setSelectionRange(0, 99999)
		document.execCommand('copy')
	},
	decodeFiltersFromStateToUrl(stateData = false, fullUrl = false) {
		const state = stateData ? stateData : store.state

		let searchUrl

		if (fullUrl) {
			searchUrl = baseUrl + '/fahrzeugmarkt/?'
		} else {
			searchUrl = '&'
		}
		let features = []

		if (state.search) {
			searchUrl += 'cs=' + encodeURIComponent(state.search) + '&'
		}
		if (state.delivery) {
			searchUrl += 'delivery=now&'
		}

		if (state.filterItems) {
			for (let item in state.filterItems) {
				if (state.filterItems[item].adPropertyType === 'bool') {
					features.push(state.filterItems[item].adPropertyKey)
				} else if (
					state.filterItems[item].adPropertyType === 'string' ||
					state.filterItems[item].adPropertyType === 'number'
				) {
					searchUrl +=
						'cf[' +
						state.filterItems[item].adPropertyKey +
						']=' +
						state.filterItems[item].adPropertyValue +
						'&'
				}
			}
		}

		if (features.length > 0) {
			searchUrl += 'cb=' + features.join() + '&'
		}

		if (state.storeId !== false) {
			searchUrl += 'store=' + state.storeId + '&'
		}

		if (state.price.filter !== 'fixed') {
			searchUrl += 'price=' + state.price.filter + '&'
		}

		if (state.pageNum > 1) {
			searchUrl += 'page=' + state.pageNum + '&'
		}

		if (
			state.sortItems.adProperty !== 'images' ||
			state.sortItems.sortOrder !== -1
		) {
			const order = state.sortItems.sortOrder === 1 ? 'ASC' : 'DESC'
			searchUrl += 'sort=' + state.sortItems.adProperty + ',' + order + '&'
		}

		return searchUrl.slice(0, -1)
	},
	getFiltersFromUrl() {
		let urlSearch = window.location.search
		let urlParams
		if (urlSearch) {
			urlParams = '&' + urlSearch.substring(1)
		} else {
			urlParams = ''
		}
		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=encodefilterforstate' +
				urlParams
		)
	},
	getFilterFields() {
		const filters = this.decodeFiltersFromStateToUrl()
		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=getFilters' +
				filters
		)
	},
	getListItems() {
		const filters = this.decodeFiltersFromStateToUrl()
		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=getItems' +
				filters
		)
	},
	getLeasingValue(carId, km, month) {
		const queryUrl = '&id=' + carId + '&km=' + km + '&month=' + month

		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=getLeasing' +
				queryUrl
		)
	},
	getFinancingValue(carId, downPayment, month) {
		const queryUrl =
			'&id=' + carId + '&downPayment=' + downPayment + '&month=' + month

		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=getFinancing' +
				queryUrl
		)
	},
	getItem(carId) {
		return apiClient.get(viewUrl + 'getItem&carId=' + carId)
	},
	getRefData() {
		return apiClient.get(
			'index.php?option=com_darmas&view=carmarket&format=json&task=getRefData'
		)
	},
	filtersActive() {
		const state = store.state
		let active = false

		if (state.search) {
			active = true
		}
		if (state.delivery) {
			active = true
		}
		if (state.filterItems) {
			active = true
		}
		if (state.storeId !== false) {
			active = true
		}
		if (state.price.filter !== 'fixed') {
			active = true
		}
		if (
			state.sortItems.adProperty !== 'images' ||
			state.sortItems.sortOrder !== -1
		) {
			active = true
		}

		return active
	},
}
